import { createApiClient, unwrap, type ApiClient } from "@riea-water/api-client";
import type { AuthAdapter } from "../auth/types.js";

/** The one client the console calls (rule 1). Built once an adapter exists, so every call carries the token. */
export function makeClient(auth: AuthAdapter, onUnauthorised: () => void): ApiClient {
  return createApiClient({
    baseUrl: `${window.location.origin}/api/v1`,
    getToken: () => auth.getToken(),
    onUnauthorised,
  });
}

export { unwrap };
